import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import DetailItem from '../../../CSIComponents/DetailItem';
import Collapse, {Panel} from '../../../ui/Collapse';
interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,
    disableTabPanes?: void | any,
    detail?: any,
    cancelAndSave?: void | any,
    tableCurrentData?: any,
    scheduleAndChargeData?: void | any,
    detailData?: void | any,
}

const defaultOperationTime = [
    { dayoftheweek: "Mon", endtime: null, starttime: "" },
    { dayoftheweek: "Tue", endtime: null, starttime: "" },
    { dayoftheweek: "Wed", endtime: null, starttime: "" },
    { dayoftheweek: "Thu", endtime: null, starttime: "" },
    { dayoftheweek: "Fri", endtime: null, starttime: "" },
    { dayoftheweek: "Sat", endtime: null, starttime: "" },
    { dayoftheweek: "Sun", endtime: null, starttime: "" }
] as {}[]

const ScheduleAndChargeDetail = (props: propsTypes) => {

    const [operationTime, setOperationTime] = useState([{}])

    useEffect(() => {
        if (props.detailData.operationtime.length < 1) {
            return setOperationTime(defaultOperationTime)
        }
        return setOperationTime(props.detailData.operationtime)
    },[props.detailData])

    const detailData = [
        { label: 'Start Date', value: props.detailData.startdate, span: 6 },
        { label: 'End Date', value: props.detailData.enddate, span: 6 },
        { span: 12 }
    ]
    const descDetail = [
        { label: 'Description', value: props.detailData.description, span: 18 },
    ]

    return (
        <>
            <Row gutter={24}>
                {detailData.map((item, i) => {
                    return (
                        <>

                            {
                                item.label ? <Col span={item.span} key={i} className="col-margin">
                                    <DetailItem value={item.value} label={item.label} />
                                </Col> : <Col span={item.span} key={i}></Col>
                            }

                        </>

                    )
                })
                }
                <Row>
                    <div className="row-marginbottom">


                        {/* <Table
                        columns={columns}
                        dataSource={
                            data
                        }
                        pagination={false}
                    /> */}
                    </div></Row>
            </Row>
            <Row gutter={24}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '75%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column-reverse', marginRight: 5, fontWeight: 'bold', }}>
                        <div style={{ height: 35 }}>Close</div>
                        <div style={{ height: 35 }}>Open</div>
                    </div>
                    {operationTime.map((item: any) => {
                        return (
                            <div style={{ flex: 1, 'userSelect': 'none' }}>
                                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>{item.dayoftheweek}</div>
                                <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', padding: '20 0' }}>
                                    <div style={{ height: 40, lineHeight: '40px', width: '60%', margin: 'auto', cursor: 'pointer' }}><span className="blue-font">{item.starttime}</span></div>
                                </div>
                                <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', borderTop: '0', padding: '20 0' }}>
                                    <div style={{ height: 40, lineHeight: '40px', width: '60%', margin: 'auto', cursor: 'pointer' }}><span className="blue-font">{item.endtime}</span></div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Row>
            <Row gutter={24} style={{ marginTop: '12px' }}>

                {descDetail.map((item, i) => {
                    return (
                        <>

                            {
                                item.label ? <Col span={item.span} key={i} className="col-margin">
                                    <DetailItem value={item.value} label={item.label} />
                                </Col> : <Col span={item.span} key={i}></Col>
                            }

                        </>

                    )
                })
                }

            </Row>
            <Row gutter={24}>
                <div style={{ width: '75%', marginTop: '30px' }}>
                    <Collapse
                        defaultActiveKey={props?.detailData?.charge?.map((_: object, i : number) => i)}
                        multiCollapseButton
                    >
                        {props?.detailData?.charge && props?.detailData?.charge?.length > 0 && props.detailData.charge.map((item: any, index: any) => {
                            return (
                                <Panel header={`Charge ${index + 1}`} key={index} style={{ marginBottom: '20px' }}>
                                    <Row gutter={24}>
                                        <Col span={8}>
                                            <DetailItem value={item.type} label='Charge Type' span={6} />
                                        </Col>
                                        {
                                            item.type === "Amount" ? <>
                                                <Col span={8}>
                                                    <DetailItem value={item.charge} label='Charge(Amount)' span={6} />
                                                </Col>
                                                <Col span={8}>
                                                    <DetailItem value={item.currency} label='Currency' span={6} />
                                                </Col>
                                            </> : <>
                                                <Col span={8}>
                                                    <DetailItem value={item.charge} label='Charge(Percent)' span={6} />
                                                </Col>
                                            </>
                                        }
                                    </Row>
                                    <Row gutter={24}>
                                        <Col span={8}>
                                            <DetailItem value={item.chargeunit} label='Charge Unit' span={6} />
                                        </Col>
                                        <Col span={8}>
                                            <DetailItem value={item.chargefrequency} label='Charge Frequency' span={6} />
                                        </Col>
                                    </Row>
                                </Panel>

                            )
                        })}
                    </Collapse>
                </div>
            </Row >

        </>
    )
}

export default ScheduleAndChargeDetail;
